// TODO: sitetitle and departmenttitle should always be links

import { Component, Host, Prop, getAssetPath, h } from '@stencil/core';

@Component({
  tag: 'cwru-header',
  styleUrl: 'header.css',
  shadow: true,
  assetsDirs: ['svgs'],
})
export class Header {
  @Prop() siteName: string = 'Site Name';
  @Prop() secnavtitle: string = 'Resources for:';
  @Prop() departmentName: string;
  @Prop() siteUrl: string = '//case.edu/';
  @Prop() departmentUrl: string;
  @Prop() homepage: boolean = false;
  @Prop() hassecnavtitle: boolean = false;
  @Prop() hasresourcenav: boolean = false;
  @Prop() altLogo: boolean = false;
  @Prop() hasSearchBar: boolean = true;

  render() {
    const sitetitle =
      this.homepage && !this.departmentName ? (
        <h1>
          <a href={this.siteUrl}>{this.siteName}</a>
        </h1>
      ) : (
        <div>
          <a href={this.siteUrl}>{this.siteName}</a>
        </div>
      );
    const departmenttitlelinked = this.departmentUrl ? <a href={this.departmentUrl}>{this.departmentName}</a> : this.departmentName;
    const departmenttitle = this.homepage ? <h1>{departmenttitlelinked}</h1> : <div>{departmenttitlelinked}</div>;
    const navsectitle = this.secnavtitle ? (
      <h2 id="block-secondarynavigation-menu" class="sec-menu-title">
        {this.secnavtitle}
      </h2>
    ) : (
      <div></div>
    );
    const resourcesnav = this.hasresourcenav ? (
      <div class="secondary-nav-container">
        <nav role="navigation" aria-labelledby="block-secondarynavigation-menu" id="block-secondarynavigation">
          {navsectitle}
          <div class="menu menu--secondary-navigation nav">
            <slot />
          </div>
        </nav>
      </div>
    ) : (
      <div></div>
    );
    const logoSrc = this.altLogo
      ? 'https://dudbm6bcnmy8e.cloudfront.net/cwru/img/cwru_logo_primary_white.svg'
      : 'https://dudbm6bcnmy8e.cloudfront.net/cwru/img/cwru_logo_primary_white.svg';

    const searchbar = this.hasSearchBar ? (
      <div class="search-container">
        <form action="//www.case.edu/search-results/" class="search-form" name="searchForm" role="search" aria-label="desktop search">
          <input placeholder="Search..." title="searchbox" type="search" class="search-input" name="q" maxlength="128" />
          <button type="submit" class="search-button" aria-label="Submit Search" style={{ backgroundImage: `url(${getAssetPath('./svgs/search-icon.svg')})` }}></button>
          <input type="hidden" name="cx" value="004305171799132815236:ciq4c8b3yv4" />
          <input type="hidden" name="ie" value="UTF-8" />
          <input class="hidden" role="button" name="sa" type="submit" title="search" alt="search" value="search" />
        </form>
      </div>
    ) : (
      <div></div>
    );

    return (
      <Host>
        <div id="cwruravealert"></div>
        <script src="//webapps.case.edu/t4/rave/add_banner"></script>
        <div class="header-top" role="banner" aria-label="Case Western Reserve University Logo Banner">
          <cwru-center max="var(--max-container)">
            <a href="//case.edu/">
              <img src={logoSrc} alt="Case Western Reserve University" title="Case Western Reserve University" class={this.altLogo ? 'alt-logo' : 'default-logo'} />
            </a>
          </cwru-center>
        </div>
        <div class="header">
          <cwru-center max="var(--max-container)">
            <cwru-switcher space="0">
              <div>
                <div class="site-name">{sitetitle}</div>
                {this.departmentName && <div class="department-name">{departmenttitle}</div>}
              </div>
              {resourcesnav}
              {searchbar}
            </cwru-switcher>
          </cwru-center>
        </div>
      </Host>
    );
  }
}
